import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/useLanguage';
import workingCatImg from '../../assets/readdy/search_working-cat-main-001__93326a6ddf.jpg';

export default function ComingSoonPage() {
  useEffect(() => {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 relative overflow-hidden">
      {/* 装饰性渐变光晕 */}
      <div className="absolute top-20 left-20 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-red-600/20 rounded-full blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* 可爱的工作小猫 */}
        <div className="mb-12 flex justify-center">
          <div className="relative">
            {/* 小猫主体 */}
            <div className="w-48 h-48 relative animate-bounce">
              <img 
                src={workingCatImg}
                alt={t('努力工作的⼩猫', 'Hard-working kitty')}
                className="w-full h-full object-contain drop-shadow-2xl"
              />
            </div>
            
            {/* 代码符号装饰 */}
            <div className="absolute -top-4 -right-4 text-purple-500 text-4xl animate-pulse">
              <i className="ri-code-s-slash-line"></i>
            </div>
            <div className="absolute -bottom-2 -left-4 text-red-500 text-3xl animate-pulse delay-300">
              <i className="ri-terminal-box-line"></i>
            </div>
          </div>
        </div>

        {/* 主标题 */}
        <h1 className="text-5xl lg:text-7xl font-bold mb-6 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 bg-clip-text text-transparent">
          {t('正在努力开发中', 'Under Active Development')}
        </h1>
        
        {/* 副标题 */}
        <p className="text-3xl lg:text-4xl font-semibold text-purple-400 mb-8">
          {t('敬请期待！', 'Stay Tuned!')}
        </p>

        {/* 进度条装饰 */}
        <div className="max-w-md mx-auto mb-16">
          <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-purple-500 to-red-500 rounded-full animate-pulse w-3/4"></div>
          </div>
          <p className="text-gray-500 text-sm mt-2">
            {t('开发进度 75%', 'Development Progress 75%')}
          </p>
        </div>

        {/* 精神股东招募卡片 */}
        <div className="max-w-2xl mx-auto mb-16 bg-gradient-to-br from-purple-600/10 to-red-600/10 border-2 border-purple-500/30 rounded-3xl p-8 backdrop-blur-sm">
          <div className="flex items-center justify-center gap-3 mb-6">
            <i className="ri-star-fill text-yellow-400 text-3xl animate-spin-slow"></i>
            <span className="text-3xl font-bold bg-gradient-to-r from-purple-400 to-red-400 bg-clip-text text-transparent">
              {t('精神股东招募中', 'Spiritual Shareholders Recruiting')}
            </span>
            <i className="ri-star-fill text-yellow-400 text-3xl animate-spin-slow"></i>
          </div>
          
          <p className="text-gray-400 text-base mb-8 leading-relaxed">
            {t(
              '我们正在打造一款令人兴奋的产品，期待您的参与和支持！如果您有合作意向，欢迎随时联系我们',
              'We are building an exciting product and looking forward to your participation and support! If you have partnership intentions, feel free to contact us anytime'
            )}
          </p>

          {/* 联系我们按钮 */}
          <button
            onClick={() => navigate('/contact')}
            className="px-10 py-4 bg-white text-gray-900 text-base font-semibold rounded-full hover:bg-gray-100 hover:shadow-2xl hover:shadow-white/20 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-message-3-line text-xl"></i>
            <span>{t('联系我们', 'Contact Us')}</span>
          </button>
        </div>

        {/* 返回按钮 */}
        <div>
          <button 
            onClick={() => window.REACT_APP_NAVIGATE('/')}
            className="px-8 py-3 bg-transparent border-2 border-gray-700 text-gray-400 text-base font-medium rounded-full hover:border-gray-600 hover:text-gray-300 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-arrow-left-line"></i>
            <span>{t('返回首页', 'Back to Home')}</span>
          </button>
        </div>

        {/* 底部装饰文字 */}
        <div className="mt-12 flex items-center justify-center gap-6 text-gray-600">
          <div className="flex items-center gap-2">
            <i className="ri-code-box-line"></i>
            <span className="text-sm">{t('全力开发中', 'In Full Development')}</span>
          </div>
          <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
          <div className="flex items-center gap-2">
            <i className="ri-rocket-line"></i>
            <span className="text-sm">{t('即将上线', 'Launching Soon')}</span>
          </div>
          <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
          <div className="flex items-center gap-2">
            <i className="ri-heart-fill text-red-500"></i>
            <span className="text-sm">{t('用心打造', 'Crafted with Care')}</span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
        .delay-300 {
          animation-delay: 300ms;
        }
      `}</style>
    </div>
  );
}
